<mat-dialog-content>
  <h1 mat-dialog-title>{{ appUIComponent.uiTitle }}</h1>
  <p>{{ appUIComponent.uiMessage }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="primary" cdkFocusInitial (click)="navigate(appUIComponent.redirect)">
    OK
  </button>
</mat-dialog-actions>
